<div *ngIf="contextMenuObject">
  <div class="d-flex space-children-mr justify-content-end" *dsRenderOnlyForBrowser="true">
    <ng-container *ngFor="let entry of (menuStandaloneEntries$ | async)">
      <ng-container *ngComponentOutlet="entry; injector: objectInjector;"></ng-container>
    </ng-container>
    <div ngbDropdown #itemOptions="ngbDropdown" placement="bottom-right"
         class="float-right ml-1" [ngClass]="optionCount === 0 ? 'd-none' : 'd-inline-block'">
      <button class="btn btn-outline-primary" id="context-menu" ngbDropdownToggle>
        <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
      </button>
      <div id="itemOptionsDropdownMenu" aria-labelledby="context-menu" ngbDropdownMenu>
        <h6 class="dropdown-header">{{'context-menu.actions.label' | translate}}</h6>
        <ng-container *ngFor="let entry of (menuEntries$ | async)">
          <ng-container *ngComponentOutlet="entry; injector: objectInjector;"></ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>
